import React, { useState } from "react"

import FlexWrapper from "../../../shared/components/fields/flex-wrapper"
import IconAction from "../../../shared/components/universal/icon-action"
import Input from "../../../shared/components/fields/input"
import LavitaCupFormStyles from "./lavita-cup.module.css"
import Radio from "../../../shared/components/fields/radio"
import ReactMarkdown from "react-markdown"
import Spacer from "../universal/spacer"
import Text from "../matrix/text"
import { errorToast } from "../../../shared/utils/error-toast"
import { genders } from "../../../shared/config/genders"
import { scrollTo } from "../../../shared/utils/smooth-scroll"
import { useForm } from "react-hook-form"
import { useMediaQuery } from "../../../hooks/use-media-query-admin"
import { usePostContact } from "../../../hooks/contact/use-query-contact"
import { useTranslation } from "react-i18next"

const LavitaCupForm = () => {
    const { t } = useTranslation("translations")
    const [isSuccess, setIsSuccess] = useState(false)

    const {
        handleSubmit,
        control,
        reset,
        register,
        formState: { errors },
    } = useForm({
        mode: "onTouched",
        defaultValues: {
            salutation: genders[0].id,
            company_name: "",
            firstname: "",
            lastname: "",
            phone: "",
            email: "",
        },
        context: undefined,
        criteriaMode: "firstError",
        shouldFocusError: true,
    })

    const mutate = usePostContact()

    const submit = async values => {
        const body = {
            category_id: process.env.CONTACT_LAVITA_CUP_CATEGORY_ID,
            firstname: values.firstname,
            lastname: values.lastname,
            email: values.email,
            phone: values.phone,
            body: t("lavita_cup_submit_body", {
                salutation: genders.find(g => g.id === values.salutation).visibleInAddress
                    ? t(genders.find(g => g.id === values.salutation).name)
                    : "",
                company_name: values.company_name,
                firstname: values.firstname,
                lastname: values.lastname,
                phone: values.phone,
                email: values.email,
            }),
        }

        try {
            await mutate.mutateAsync(body)
            reset()
            setIsSuccess(true)
            scrollTo("success_message")
        } catch (error) {
            errorToast(error)
        }
    }

    const isMobile = useMediaQuery("(max-width: 767px)", { initializeWithValue: false })

    return (
        <div className={LavitaCupFormStyles.wrapper}>
            {!isSuccess ? (
                <div className={LavitaCupFormStyles.form}>
                    <div>
                        <form onSubmit={handleSubmit(submit)} name="lavitacup">
                            <span className={LavitaCupFormStyles.label}>
                                <strong>{t("lavita_cup_headline")}</strong>
                            </span>
                            <Spacer small />
                            <Radio
                                register={register("salutation", {
                                    required: { value: true, message: t("form_error_required") },
                                })}
                                error={errors}
                                label={t("partner_form_salutation_label")}
                                flex
                                options={genders.map(g => ({
                                    label: t(g.name),
                                    value: g.id,
                                }))}
                                required
                            />
                            <FlexWrapper childWidths={isMobile ? [100, 100] : [50, 50]} wrap>
                                <Input
                                    control={control}
                                    rules={{
                                        required: {
                                            value: true,
                                            message: t("form_error_required"),
                                        },
                                    }}
                                    type="text"
                                    name="firstname"
                                    label={t("contact_form_firstname_label")}
                                    autocomplete="given-name"
                                    required
                                />
                                <Input
                                    control={control}
                                    rules={{
                                        required: {
                                            value: true,
                                            message: t("form_error_required"),
                                        },
                                    }}
                                    type="text"
                                    name="lastname"
                                    label={t("contact_form_lastname_label")}
                                    autocomplete="family-name"
                                    required
                                />
                            </FlexWrapper>
                            <FlexWrapper childWidths={isMobile ? [100, 100] : [50, 50]} wrap>
                                <Input
                                    control={control}
                                    rules={{
                                        required: {
                                            value: true,
                                            message: t("form_error_required"),
                                        },
                                    }}
                                    type="tel"
                                    name="phone"
                                    label={t("partner_form_phone_label")}
                                    required
                                />
                                <Input
                                    control={control}
                                    rules={{
                                        required: {
                                            value: true,
                                            message: t("form_error_required"),
                                        },
                                    }}
                                    type="email"
                                    name="email"
                                    label={t("contact_form_email_label")}
                                    required
                                />
                            </FlexWrapper>
                            <div>
                                <Input
                                    control={control}
                                    rules={{
                                        required: {
                                            value: true,
                                            message: t("form_error_required"),
                                        },
                                    }}
                                    type="text"
                                    name="company_name"
                                    label={t("lavita_cup_company")}
                                    required
                                />
                                <div className={LavitaCupFormStyles.smallprint}>
                                    <ReactMarkdown>{t("contact_partnership_form_smallprint")}</ReactMarkdown>
                                </div>
                                <p className={LavitaCupFormStyles.asterisk}>
                                    <span style={{ color: "#c53929" }}>* </span>
                                    {t("form_required_field")}
                                </p>
                                <Spacer small />
                                <IconAction title={t("lavita_cup_submit")} button submit />
                            </div>
                        </form>
                    </div>
                </div>
            ) : (
                <div className={LavitaCupFormStyles.success} id="success_message">
                    <div className={LavitaCupFormStyles.circle}>
                        <i className="lavita-icon"></i>
                    </div>
                    <Spacer small />
                    <Text
                        small
                        source={t("contact_partnership_form_success")}
                        align={{ desktop: "center", tablet: "center", mobile: "center" }}
                    />
                </div>
            )}
        </div>
    )
}

export default LavitaCupForm
